import React, { ChangeEvent } from 'react';
import { Col, Row } from 'react-bootstrap';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { InputSelect, InputText } from '~/components/NovosInputs';
import ToggleDefault from '~/components/ToggleDefault';
import { CgAdd } from 'react-icons/cg';
import { useClassificacaoIbsCbs } from '../../hooks/useClassificacaoIbsCbs';
import { ModalCST } from '../modalCST';
import { selectProps } from '../../types';
import Tippy from '@tippyjs/react';

export const FormClassificacao: React.FC = () => {
  const {
    formClassificao: { register, control, errors, setValue, clearErrors },
    handleOpenModal,
    openModal,
    cstOptions,
    flgPadrao,
    handleFlgPadrao,
  } = useClassificacaoIbsCbs();
  return (
    <>
      <Row className="mt-3 gx-4">
        <Col sm={12} md={4}>
          <InputSelect
            name="cod_cst_ibs_cbs"
            options={cstOptions}
            label="CST *"
            placeholder="Selecione"
            register={register}
            control={control}
            isError={!!errors.cod_cst_ibs_cbs}
            changeSelected={(selected: selectProps) => {
              setValue('cod_cst_ibs_cbs', selected);
              clearErrors('cod_cst_ibs_cbs');
            }}
          />
        </Col>
        <Col xs="auto" style={{ marginTop: '30px', marginLeft: '-15px' }}>
          <Tippy
            content="Nova CST"
            arrow
            animation="scale"
            placement="bottom"
            appendTo={() => document.body}
            trigger="mouseenter focus"
            zIndex={9999}
          >
            <span
              className="nova-cst-tippy-ref"
              style={{ display: 'inline-flex', alignItems: 'stretch' }}
              onClick={(e) => e.stopPropagation()}
            >
              <CustomButtonNovo
                onClick={() => handleOpenModal(true)}
                label=""
                width="60px"
                style={{ paddingLeft: '19px' }}
                icon={CgAdd}
                disabled={false}
              />
            </span>
          </Tippy>
        </Col>

        <Col sm={12} md={3}>
          <InputText
            name="des_classif_trib"
            label="Classif. Trib. *"
            placeholder="Digite a Classificação"
            maxLength={6}
            minLength={6}
            max={999999}
            min={0}
            register={register}
            control={control}
            isError={!!errors.des_classif_trib}
            onInput={(e: ChangeEvent<HTMLInputElement>) => {
              const numbersOnly = e.target.value.replace(/\D/g, '');
              setValue('des_classif_trib', numbersOnly);
            }}
          />
        </Col>
        <Col sm={12} md={3}>
          <InputText
            name="des_ibs_cbs"
            label="Descrição *"
            placeholder="Digite a Descrição"
            maxLength={50}
            caseInput="upper"
            min={0}
            register={register}
            control={control}
            isError={!!errors.des_ibs_cbs}
          />
        </Col>
        <Col sm={12} md={1}>
          <ToggleDefault
            labelText="Padrão *"
            setChecked={flgPadrao}
            onSwitch={() => handleFlgPadrao(!flgPadrao)}
          />
        </Col>
      </Row>
      {openModal && <ModalCST />}
    </>
  );
};
